var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_73_15003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H97V97H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_73_15003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 85.4434C48.5 78.8845 53.242 73.2862 59.7118 72.2082L83.7383 68.3926V35.9563",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7383 19.8793V11.5566L59.7118 15.3722C53.242 16.4502 48.5 22.0486 48.5 28.6074",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 85.4434C48.5 78.8845 43.758 73.2862 37.2882 72.2082L13.2617 68.3926V11.5566L37.2882 15.3722C43.758 16.4502 48.5 22.0486 48.5 28.6074V85.4434Z",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7401 19.8813L85.4035 18.216C87.622 15.9954 91.2216 15.9954 93.4401 18.216C94.5505 19.3243 95.1054 20.7791 95.1054 22.2343C95.1054 23.6893 94.5505 25.1441 93.4401 26.2526L73.2027 46.4898L58.4481 53.2078L65.1661 38.4532L83.7401 19.8813Z",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1661 38.4531L73.2027 46.4897",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3834 22.2342L89.4219 30.2727",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6758 78.8125C76.6304 78.8125 75.7812 77.9634 75.7812 76.918C75.7812 75.8726 76.6304 75.0234 77.6758 75.0234C78.7212 75.0234 79.5703 75.8726 79.5703 76.918C79.5703 77.9634 78.7212 78.8125 77.6758 78.8125Z",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 22.9238H1.89453V79.7598H34.7779C39.9253 79.7598 44.8606 81.804 48.5 85.4434C52.1394 81.804 57.0746 79.7598 62.2221 79.7598H69.6373",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 79.7598H95.1054V22.2342",
    stroke: "#717171",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.9bbe81e92a1b38f649d1b6a0a1c34e87.svg";
export { ForwardRef as ReactComponent };